/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Card from "components/card";
import axios from "axios";
import {
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { FaAngleLeft } from "react-icons/fa";
import { MdOutlineContentCopy } from "react-icons/md";
import { Tooltip, IconButton } from "@mui/material";
import SweetAlert2 from "react-sweetalert2";

import DetailsTab from "./components/DetailsTab";
// import AccessControlTab from "../shared/AccessControlTab";
import SubaccountsTab from "./components/SubaccountsTab";
import { useParams, useNavigate } from "react-router-dom";
import { TokenManager } from "utils/tokenManager";

const MerchantDetail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [merchantDetailForEdit, setMerchantDetailForEdit] = useState(null);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [swalProps, setSwalProps] = useState<any>({});
  const { merchant_id } = useParams();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();
  const [isImpersonating, setIsImpersonatingLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await fetchMerchantDetail();
    };

    fetchData();
  }, []);

  const fetchMerchantDetail = async () => {
    try {
      setIsProcessing(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `/api/merchant/get-merchant-by-id?merchantid=${merchant_id}`
      );

      let merchantData = response.data.merchant?.payload;

      // Check if merchant data exists, if not redirect to merchant listing
      if (!merchantData) {
        console.error("Merchant not found");
        navigate(`/${userRole}/merchants/manage`);
        return;
      }

      setMerchantDetailForEdit(merchantData);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data", error);
      // Redirect to merchant listing page on error
      navigate(`/${userRole}/merchants/manage`);
    }
  };

  const handleClickCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handleImpersonateAsMerchant = async () => {
    if (!merchant_id) return;
    setIsImpersonatingLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/api/user/request",
        {
          fn: "impersonate",
          merchantId: merchant_id,
          merchantName: (merchantDetailForEdit as any)?.name || (merchantDetailForEdit as any)?.merchant_name || "",
        }
      );
      const data = response.data;
      if (data.status === "ok") {
        TokenManager.storeImpersonationState();
        const timeZone = localStorage.getItem("time_zone") || "";
        TokenManager.storeTokens(data.token, data.expires, timeZone);
        localStorage.setItem("userRole", data.role);
        localStorage.setItem("merchantId", merchant_id);
        localStorage.setItem("merchantName", data.merchantName || "");
        localStorage.removeItem("subaccountId");
        localStorage.removeItem("subaccountName");
        localStorage.setItem("isImpersonating", "true");
        localStorage.setItem("impersonatingAs", data.role);
        localStorage.setItem("impersonatingName", data.merchantName || "");
        localStorage.setItem("impersonatingReturnPath", window.location.pathname);
        window.location.href = `/${data.role.toLowerCase()}/dashboard`;
      }
    } catch (error) {
      console.error("Impersonation failed:", error);
      setSwalProps({
        show: true,
        title: "Error",
        text: "Failed to impersonate as this merchant",
        icon: "error",
      });
    } finally {
      setIsImpersonatingLoading(false);
    }
  };

  return (
    <>
      <Card className="card card-pad !rounded-xl">
        <div className="mb-3 flex items-center justify-between">
          <div>
            <button
              type="button"
              onClick={() => navigate(`/${userRole}/merchants/manage`)}
              disabled={isUpdating || isImpersonating}
              className="
                mb-1 inline-flex items-center gap-1
                text-sm font-medium text-gray-700
                transition hover:text-gray-700
                disabled:cursor-not-allowed disabled:opacity-40
                dark:text-gray-400 dark:hover:text-white
              "
            >
              <FaAngleLeft className="text-base" />
              <span>Merchants</span>
            </button>

            <h3 className="text-xl font-semibold text-navy-700">
              {(merchantDetailForEdit as any)?.name ||
                (merchantDetailForEdit as any)?.merchant_name ||
                "—"}
            </h3>
            <div className="flex items-center gap-1 text-sm text-gray-500">
              ID: {merchant_id}
              <Tooltip title="Copy Merchant ID" arrow placement="top">
                <IconButton
                  size="small"
                  disabled={isImpersonating}
                  onClick={() => handleClickCopy(merchant_id)}
                >
                  <MdOutlineContentCopy className="h-3.5 w-3.5 text-gray-500" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          {userRole === "superadmin" && !TokenManager.isImpersonating() && merchantDetailForEdit && (
            <Button
              onClick={handleImpersonateAsMerchant}
              isLoading={isImpersonating}
              loadingText="Impersonating..."
              size="sm"
              className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-medium text-white hover:bg-amber-600 transition-colors"
            >
              Impersonate as Merchant
            </Button>
          )}
        </div>

        <Tabs className="mt-3">
          <TabList className="rounded-tl-custom rounded-tr-custom scrollbar-hide flex flex-wrap overflow-x-auto sm:flex-nowrap">
            <Tab
              className={`child-tab rounded-tl-custom rounded-tr-custom sm:text-md whitespace-nowrap bg-white px-4 py-3 pt-4 text-sm text-navy-700 sm:px-6 sm:py-4 sm:pt-6 ${
                isLoading ||
                isUpdating ||
                isProcessing ||
                isImpersonating ||
                merchantDetailForEdit === null
                  ? "pointer-events-none opacity-50"
                  : ""
              }`}
            >
              Details
            </Tab>
            <Tab
              className={`child-tab rounded-tl-custom rounded-tr-custom sm:text-md whitespace-nowrap bg-white px-4 py-3 pt-4 text-sm text-navy-700 sm:px-6 sm:py-4 sm:pt-6 ${
                isLoading ||
                isUpdating ||
                isProcessing ||
                isImpersonating ||
                merchantDetailForEdit === null
                  ? "pointer-events-none opacity-50"
                  : ""
              }`}
            >
              {merchantDetailForEdit === null
                ? ""
                : (merchantDetailForEdit as any)?.entity_type === "AGNT#"
                ? "Agents"
                : "Subaccounts"}
            </Tab>
          </TabList>

          <TabPanels className="rounded-bl-custom rounded-br-custom border-t border-gray-200 bg-white">
            <TabPanel>
              <DetailsTab
                data={merchantDetailForEdit}
                setSwalProps={setSwalProps}
                isOtherTabUpdating={isUpdating}
                isImpersonating={isImpersonating}
              />
            </TabPanel>
            {/* <TabPanel>
            <AccessControlTab
              data={merchantDetailForEdit}
              mode="merchant"
              is_active={merchantDetailForEdit?.is_active}
              auth1={merchantDetailForEdit?.auth1}
              auth2={merchantDetailForEdit?.auth2}
              isProcessing={isProcessing}
              setSwalProps={setSwalProps}
              fetchDetail={fetchMerchantDetail}
              isOtherTabUpdating={isUpdating}
              setIsUpdating={setIsUpdating}
            />
          </TabPanel> */}
            <TabPanel>
              <SubaccountsTab merchant={merchantDetailForEdit} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>

      <SweetAlert2
        {...swalProps}
        customClass={{
          actions: "custom-swal2-popup-action",
          title: "custom-swal2-popup-title",
          confirmButton:
            "custom-swal2-popup-action custom-swal2-popup-action-confirm",
          cancelButton:
            "custom-swal2-popup-action custom-swal2-popup-action-cancel",
        }}
      ></SweetAlert2>
    </>
  );
};

export default MerchantDetail;
